<template>
  <b-field
    :label="label"
    :type="(hasError() ? 'is-danger': '')"
    :message="errorMessage()"
  >
    <b-numberinput
      :value="value"
      :placeholder="placeholder"
      :step="step"
      :min="min"
      :max="max"
      :size="size"
      :disabled="disabled"
      type="is-light"
      :class="{'is-danger': hasError()}"
      :controls-alignment="suffix ? 'left' : 'right'"
      controls-position="compact"
      @input="inputListener"
    />
    <p
      v-if="suffix"
      class="control"
    >
      <span
        class="input-suffix"
        :class="[{'is-disabled': disabled}, size]"
      >{{ suffix }}</span>
    </p>
  </b-field>
</template>

<script>
import InputBase from "./InputBase";

export default {
  extends: InputBase,
  props: {
    value: {
      required: true,
      validator: (value) => {
        return _.isNumber(value) || value === null;
      }
    },
    step: {
      default: 1,
      type: Number
    },
    min: {
      type: Number,
      default: undefined
    },
    max: {
      type: Number,
      default: undefined
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    suffix: {
      default: null,
      type: String
    },
    size: {
      default: undefined,
      type: String
    }
  }
};
</script>

<style scoped>
.b-numberinput {
  max-width: 250px;
}
</style>
